/**
 * Componente principal del sidebar, que contiene el logo, los items y el usuario 
 * y que se muestra al hacer click en el icono de hamburguesa 
 */

import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import SidebarSection from './sidebar-section';
import SidebarUser from './sidebar-user';
import KyriosCo_Outline from '../../assets/logos/KyriosCo._Outline.avif';
import KyriosCo_Color from '../../assets/logos/KyriosCo._Color.avif';
import './sidebar-menu.css';
import { useUsuario } from '../../context/usuarioContext';

export default function SidebarMenu() {
  const [visible, setVisible] = useState(false);
  const { tienePermiso } = useUsuario();

  const modulos = [
    { label: 'Inicio', icon: 'pi pi-home', path: '/app' },
    { label: 'Inventario', icon: 'pi pi-warehouse', path: '/app/inventario-tk', modulo: 'Inventario', permiso: 'ACCESO_MOD_INV' },
    { label: 'Taller Mecánico', icon: 'pi pi-wrench', path: '/app/taller', modulo: 'Taller Mecánico', permiso: 'ACCESO_MOD_MEC' },
    { label: 'Vehículos', icon: 'pi pi-car', path: '/app/panel-vehiculos', modulo: 'Panel Vehículos', permiso: 'ACCESO_MOD_VEH' },
    { label: 'Conductor', icon: 'pi pi-user', path: '/app/panel-conductor', modulo: 'Panel Conductor', permiso: 'ACCESO_MOD_CON' },
    { label: 'Prevención', icon: 'pi pi-user', path: '/app/panel-prevencion', modulo: 'Panel Prevención', permiso: 'ACCESO_MOD_PRE' },
    { label: 'Gestión de Personas', icon: 'pi pi-users', children: [
      { label: 'Crear Persona/Usuario', icon: 'pi pi-plus', path: '/app/gestion-personas/persona/crear-nuevo', modulo: 'Gestión de Personas', permiso: 'PER_REGISTRAR_PERSONA'},
      { label: 'Restablecer Contraseña', icon: 'pi pi-user-edit', path: '/app/gestion-personas/usuario/administrar', modulo: 'Gestión de Personas', permiso: 'ACCESO_MOD_PER'},
      // { label: 'Ver Usuarios', icon: 'pi pi-users', path: '/app/gestion-personas/ver/personas', modulo: 'Gestión de Personas', permiso: 'PER_VER_USUARIOS'},
    ], modulo: 'Gestión de Personas', permiso: 'ACCESO_MOD_PER'}, 
  ]

  const informes = [
    { label: 'Inventario', icon: 'pi pi-chart-bar', path: 'reporte/inventario-tk' },
    { label: 'Taller Mecánico', icon: 'pi pi-chart-bar', path: 'reportes/taller' },
  ]

  const modulosVisibles = modulos.filter(item => {
    if (!item.modulo) return true;
    return tienePermiso(item.modulo, item.permiso)
  });

  const informesVisibles = informes.filter(item => {
    return tienePermiso(item.modulo, item.permiso)
  });

  return (
    <>
      <div className='navbar-sidebar'>
        <Button icon="pi pi-bars" onClick={() => setVisible(true)} className="toggle-dashboard m-3" />
        <img src={KyriosCo_Outline} alt="Kyrios Co." className="sidebar-logo" />
      </div>

      <Sidebar 
        visible={visible} 
        onHide={() => setVisible(false)} 
        className="p-sidebar-xs pb-0" 
        position="left" 
        showCloseIcon={true} 
        header={
          <div className="flex align-items-center justify-content-between w-full p-0 m-0">
            <img src={KyriosCo_Color} alt="Kyrios Co." className="sidebar-logo"/>
          </div>
        }>
        <div className="sidebar-container">
          <div className="sidebar-scrollable">
            <SidebarSection 
              title="MÓDULOS" 
              items={modulosVisibles} 
              onSelect={() => setVisible(false)}
            />

            {informesVisibles.length > 0 && (
              <SidebarSection 
                title="INFORMES"
                items={informesVisibles}
                onSelect={() => setVisible(false)}
              /> 
            )}
          </div>
          <div className="sidebar-footer">
            <SidebarUser image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" />
          </div>
        </div>
      </Sidebar>
    </>
  );
}
